

import AddVehiclesContainer from 'containers/AddVehicles/index'
import React from 'react'

const AddVehiclesPage = () => {
  return (
   <>
   <AddVehiclesContainer/>
   </>
  )
}

export default AddVehiclesPage